import { define } from '@subaio/validation'

type FieldsOptional = {
	digitsErrorMessage: string
	startErrorMessage: string
}

type Fields = FieldsOptional & {
	requiredErrorMessage: string
}

const validate = ({ digitsErrorMessage, startErrorMessage }: FieldsOptional, value: unknown) => {
	if (typeof value !== 'string') return digitsErrorMessage
	// Check if string starts with "+" or "0"
	if (!/^(\+|0)/.test(value)) return startErrorMessage
	// Check if string includes anything but numbers and spaces after start
	if (!/^\+?[\d ]*$/.test(value)) return digitsErrorMessage

	return true
}

export const fieldPhoneNumber = (fields: Fields) =>
	define<string>('fieldPhoneNumber', (value) => {
		if (value === undefined || value === null) return fields.requiredErrorMessage
		return validate(fields, value)
	})

export const fieldPhoneNumberOptional = (fields: FieldsOptional) =>
	define<string | undefined>('fieldPhoneNumberOptional', (value) => {
		if (value === undefined || value === null) return true
		return validate(fields, value)
	})
